import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownEmpty} from '../../../components/common/dropdowns/dropdownEmpty';
import {IntegrationTypeModel} from '../../../models/api/integrationTypesModel';
import {SettingsAppsAllUrl} from '../../../models/url/settingsUrlModel';
import {AppsGrid} from '../layout/appsGrid';
import {SettingsAppCardContainer} from '../settingsAppCardContainer';
import {renderMultiLoadingState} from './settingsAppsPageHelpers';

/*
 * Props.
 */

interface SettingsAppsAllPageProps {
  integrationTypes: ReadonlyArray<IntegrationTypeModel>;
  isIntegrationTypesLoading: boolean;
  url: SettingsAppsAllUrl;
}

/*
 * Style.
 */

const StyledDropdownEmpty = styled(DropdownEmpty)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

/*
 * Component.
 */

export const SettingsAppsAllPage: FC<SettingsAppsAllPageProps> = ({
  integrationTypes,
  isIntegrationTypesLoading,
  url,
}) => {
  const shouldRenderEmptyState = integrationTypes.length === 0 && !isIntegrationTypesLoading;
  return (
    <AppsGrid
      isLoading={isIntegrationTypesLoading}
      renderLoadingState={renderMultiLoadingState}
      shouldHaveLoadingGradient
    >
      {integrationTypes.map((integrationType) => (
        <SettingsAppCardContainer key={integrationType.id} integrationType={integrationType} url={url} />
      ))}
      {shouldRenderEmptyState && <StyledDropdownEmpty />}
    </AppsGrid>
  );
};
